/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import AdminLayout from "layouts/Admin/Admin.js";
import RTLLayout from "layouts/RTL/RTL.js";

import "assets/scss/black-dashboard-react.scss";
import "assets/demo/demo.css";
import "assets/css/nucleo-icons.css";
import "assets/css/modern-theme.css";
import "assets/css/premium-upgrade.css";
import "assets/css/process-explanation.css";
import "assets/css/mobile-menu-fix.css";
import "assets/css/firebase-auth.css";


import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { FirebaseAuthProvider } from './contexts/FirebaseAuthContext';
import { Analytics } from '@vercel/analytics/react';
import './test-env'; // Temporary test file

// Disable all console logging for security
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
}


const googleid = process.env.REACT_APP_GOOGLE_ID;

// Environment variables are loaded but not logged for security



const root = ReactDOM.createRoot(document.getElementById("root"));

// Parse URL parameters to check for `redirect=true`
const searchParams = new URLSearchParams(window.location.search);
const shouldRedirect = searchParams.get("redirect") === "true";

// Check if Google ID is available (silent check for security)

root.render(
<GoogleOAuthProvider clientId={googleid || ''}>
  <FirebaseAuthProvider>
    <ThemeContextWrapper>
      <BackgroundColorWrapper>
        <BrowserRouter>
          <Routes>
            {/* Conditionally redirect to /admin/getactivities based on URL parameter */}
            {shouldRedirect ? (
                <>              
                <Route path="/admin/*" element={<AdminLayout />} />
                <Route path="/rtl/*" element={<RTLLayout />} />
                <Route path="*" element={<Navigate to="/admin/getactivities" replace />} />
              </>  
              ) : (
                <>
                  
                  <Route path="/admin/*" element={<AdminLayout />} />
                  <Route path="/rtl/*" element={<RTLLayout />} />
                  <Route path="*" element={<Navigate to="/admin/features" replace />} />
                </>
              )}
            
          </Routes>
        </BrowserRouter>
        <Analytics />
      </BackgroundColorWrapper>
    </ThemeContextWrapper>
  </FirebaseAuthProvider>
  </GoogleOAuthProvider>
);
